import React, { Component } from 'react'
import { Button, Divider, Modal } from 'semantic-ui-react'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as moment from 'moment';
import { ref, getOrderKey } from '../../../../config/constants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

export default class DuplicateOrderMistake extends Component {
    constructor(props) {
        super(props);

        this.state = ({
            modalOpen: false
        })
    }

    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });

    }

    deleteDuplicate = () => {
        console.log("++++++++: delete duplicate: +++++++++");


        //GET NEW ORDER NUMBER
        
        console.log("deleting - :" + getOrderKey(this.props.order));
        ref.child('deleteOrders/' + getOrderKey(this.props.order)).set(this.props.order);
        ref.child('orders/' + getOrderKey(this.props.order)).set(null);
        console.log("order deleted");

        this.closeModal();
    }

    
    render() {
        return (
            <div>
                <Divider horizontal>{'DELETE THIS ORDER'}</Divider>

                <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
                    <Modal.Header>
                        Duplicate Order
                </Modal.Header>
                    <Modal.Content>
                        <p>Are you sure you delete this duplicate order? IT CANNOT BE REVERSED!! MAKE SURE!!</p>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeModal}>
                            No
                        </Button>
                        <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.deleteDuplicate} />
                    </Modal.Actions>
                </Modal>

                <Button color='red' fluid onClick={this.openModal} >DELETE ORDER </Button>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/DuplicateOrder/DuplicateOrderMistake.js